import React, { useState } from 'react';

const About = () => {
  const [activeTab, setActiveTab] = useState('home');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <section className="about">
        <div className="container pos-rel">
          <div className="about-top pb-150">
            <div className="row align-items-end mt-none-30">
              <div className="col-lg-6 mt-30">
                <div className="about-logo wow fadeInUp">
                  <img src="assets/img/about/b_logo.png" alt="Company Logo" />
                </div>
              </div>
              <div className="col-lg-6 mt-30">
                <div className="section-title">
                  <span className="sub-title wow fadeInRight" data-wow-duration=".7s">
                    About Om Softwares
                  </span>
                  <h3 className="title xb-split-text split-in-right">
                    Crafting Digital <span>Excellence</span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="abut-bottom">
            <div className="row align-items-center mt-none-30">
              <div className="col-lg-6 mt-30">
                <ul className="nav nav-tabs about-nav" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'home' ? 'active' : ''}`}
                      role="tab"
                      aria-selected={activeTab === 'home'}
                      onClick={() => handleTabClick('home')}
                    >
                      Our Mission
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'vision' ? 'active' : ''}`}
                      role="tab"
                      aria-selected={activeTab === 'vision'}
                      onClick={() => handleTabClick('vision')}
                    >
                      Our Vision
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === 'values' ? 'active' : ''}`}
                      role="tab"
                      aria-selected={activeTab === 'values'}
                      onClick={() => handleTabClick('values')}
                    >
                      Values
                    </button>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    className={`tab-pane fade ${activeTab === 'home' ? 'show active' : ''}`}
                    role="tabpanel"
                  >
                    <div className="about-paragraph">
                      <p>
                        Our mission is to empower businesses and individuals by harnessing the limitless possibilities of the digital landscape. At Om Softwares, we focus on delivering tailored web development and social media management solutions that help brands grow, connect, and thrive. Every project we undertake is driven by a passion for innovation and a commitment to excellence.
                      </p>
                      <p>
                        We believe that creativity, collaboration, and understanding our clients’ unique needs are the cornerstones of impactful results. Whether it's creating stunning websites or elevating social media engagement, our mission is to go beyond expectations and deliver solutions that truly make a difference.
                      </p>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${activeTab === 'vision' ? 'show active' : ''}`}
                    role="tabpanel"
                  >
                    <div className="about-paragraph">
                      <p>
                        Our vision is to lead the way in social media management and web development by setting new benchmarks for quality and innovation. We aspire to be recognized not just for the solutions we provide but for the trust we build with our clients. As a forward-thinking agency, we aim to shape the future of digital communication by staying ahead of trends and continuously evolving our strategies.
                      </p>
                      <p>
                        We envision a world where businesses effortlessly connect with their audiences, and individuals realize their dreams through impactful digital solutions. By being a catalyst for success, Om Softwares strives to leave a lasting legacy in the digital domain.
                      </p>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${activeTab === 'values' ? 'show active' : ''}`}
                    role="tabpanel"
                  >
                    <div className="about-paragraph">
                      <p>
                        At Om Softwares, our values reflect who we are and what we stand for. Integrity is at the heart of everything we do, ensuring transparency and trust in our partnerships. Excellence drives us to deliver work that consistently exceeds expectations, while innovation inspires us to push boundaries and find creative solutions.
                      </p>
                      <p>
                        We are committed to fostering genuine connections—between businesses and their audiences, and within our own team. By prioritizing collaboration, empathy, and a relentless pursuit of growth, we ensure that our clients receive the very best in social media management and web development.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mt-30">
                <div className="about-right">
                  <div className="about-img pos-rel">
                    <img
                      className="ukiyo"
                      data-u-speed="1.2"
                      src="assets/img/about/about_img.webp"
                      alt="About Visual"
                    />
                    <div className="about-year">
                      <h2>5</h2>
                      <p>
                        Year of <br />
                        Experience
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="about-icon">
            <img src="assets/img/icon/about_icon.png" alt="Decorative Icon" />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;